import { BetonOrderCalcResult, BetonOrderFormInitialData } from '@beton/const';
import { MemoizedSelector, createSelector } from '@ngrx/store';
import { HttpErrorModel, StateUtils } from '@spartacus/core';
import { StateWithBeton } from '../beton-state';
import { getBetonState } from './feature.selector';

export const getBetonOrderInitialDataState = (): MemoizedSelector<
  StateWithBeton,
  StateUtils.LoaderState<BetonOrderFormInitialData>
> => createSelector(getBetonState, (state) => state.initialData);

export const getCalculateOrderState = (): MemoizedSelector<
  StateWithBeton,
  StateUtils.LoaderState<BetonOrderCalcResult>
> => createSelector(getBetonState, (state) => state.calculateOrder);
export const getCalculateOrderError = (): MemoizedSelector<StateWithBeton, HttpErrorModel> =>
  createSelector(getBetonState, (state) => state.calculateOrderError);

export const getConfirmOrderState = (): MemoizedSelector<StateWithBeton, StateUtils.LoaderState<unknown>> =>
  createSelector(getBetonState, (state) => state.confirmOrder);
export const getConfirmOrderError = (): MemoizedSelector<StateWithBeton, HttpErrorModel> =>
  createSelector(getBetonState, (state) => state.confirmOrderError);
